import React from "react";
import { LOGOS, WELCOME_HEADING, SUGGESTIONS, TOGGLE_SUGGESTION } from "../config";
import "./WelcomeScreen.css";
import Avatar from "./Avatar";

export default function WelcomeScreen({ onSuggestion, welcomemessages, chat_widget_icon, statusLabel }) {
  const isConnected = statusLabel === "Connected";

  return (
    <div className="welcome-screen">
      <div className="welcome-body">
        <div className="welcome-logo">
          {isConnected ? (
            <Avatar
              src={chat_widget_icon || LOGOS.logo}
              alt="Arya"
              className="welcome-logo-img"
            />
          ) : (
            <div className="skeleton logo" />
          )}
        </div>

        <div className="welcome-text">
          {isConnected ? (
            <p className="welcome-title">{welcomemessages || WELCOME_HEADING}</p>
          ) : (
            <>
              <div className="skeleton line medium" />
              <div className="skeleton line medium" />
              <div className="skeleton line short" />
            </>
          )}
        </div>

        {isConnected && TOGGLE_SUGGESTION && SUGGESTIONS.length > 0 && (
          <div className="welcome-suggestions">
            {SUGGESTIONS.map((s) => (
              <button
                key={s}
                className="suggestion-chip"
                onClick={() => onSuggestion(s)}
              >
                {s}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
